import React from 'react';
import PropTypes from 'prop-types';

import FullLogo from 'assets/barstool/branding-logos/full-logo.svg';
import FullLogoDark from 'assets/barstool/branding-logos/full-logo-dark.svg';
import WhiteLogo from 'assets/barstool/branding-logos/white-logo.svg';

const BrandLogo = ({ type, className }) => {
  let Component = null;
  switch (type) {
    case 'standard':
      Component = FullLogo;
      break;
    case 'dark':
      Component = FullLogoDark;
      break;
    case 'light':
      Component = WhiteLogo;
      break;
    default:
      Component = FullLogo;
  }

  return <Component className={className} />;
};

BrandLogo.defaultProps = {
  type: 'standard',
  className: '',
};

BrandLogo.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
};

export default BrandLogo;
